import * as React from 'react';
import UzPravaPrj from './akc/UzPravaPrj';
import PravaPrj from './akc/PravaPrj';
import PravaUz from './akc/PravaUz';
import PravaSkup from './akc/PravaSkup';
import Seq from './akc/Seq';
import UzWizard from './akc/UzWizard';

const akcFactory = (akc, state, showMsg, obj, customAkcFactory) => {
  const { selected } = state[state.primaryField];
  const db = state.db;

  const customAkc = customAkcFactory ? customAkcFactory(akc, state, showMsg, obj) : null;
  if (customAkc) return customAkc

  switch (akc) {
    case 51:
      return (
        <PravaPrj
          selected={selected}
          db={db}
          showMsg={showMsg}
        />
      );
    case 52:
      return (
        <PravaSkup
          selected={selected}
          db={db}
          showMsg={showMsg}
        />
      );
    case 56:
      return (
        <PravaUz
          selected={selected}
          db={db}
          showMsg={showMsg}
        />
      );
    case 57:
      return (
        <UzWizard
          db={db}
          selected={selected}
          akc={state.akc}
        />
      )
    case 58:
      return (
        <Seq
          db={db}
          selected={selected}
          showMsg={showMsg}
        />
      );
    case 99:
      return (
        <UzPravaPrj
          selected={selected}
          db={db}
          primaryField={state.primaryField}
          showMsg={showMsg}
        />
      );
    default:
      return null;
  }
}

export default akcFactory;